<template lang="pug">
.cp-product-list2
  .w.fix
    img.fl(:src="imgSrc")
    .list-wrap.fr
      .item(v-for="v in config.list")
        icon.icon(:iconClass="v.iconClass")
        p {{ v.label }}
        p {{ v.content }}
</template>
<script>
export default {
  components: {},
  props: {
    config: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
    }
  },
  computed: {
    imgSrc () {
      return require(`../../../assets/${this.config.img}`)
    }
  },
  methods: {}
}
</script>
<style lang="stylus">
.cp-product-list2
  position relative
  background url('../../../assets/jianbiandi.png') center / 100% no-repeat
  background-size: cover;
  img
    width 360px
    margin-left 40px
    margin-top 140px
  .list-wrap
    width 650px
    padding 65px 0px
    margin-right 25px
    display flex
    flex-wrap wrap
    justify-content space-between
    .item
      width 260px
      .icon
        font-size 58px
      &:nth-child(1)
        margin-bottom 80px
      &:nth-child(2)
        margin-bottom 80px
      p
        &:nth-child(2)
          font-size 24px
          font-weight 600
          margin-top 25px
          margin-bottom 10px
        &:last-child
          font-size 16px
          color #F4F5F7
          text-align left
</style>
